export default __webpack_public_path__ + "static/media/result-page.731fdb50.jpg";